const base = require("../product/base");
const $body = $("body");
const { updateCartTotals, clearCouponError, appendToUrl, validateBasket, createErrorNotification, updateApproachingDiscounts } = require("../components/cartHelper");
const isLoyaltyEnabled = $("meta[name=isLoyaltyEnabled]").attr("content") === "true";

module.exports = function () {
    $(".promo-code-form").submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        const $form = $(this);
        const $formControl = $form.find(".form-control");

        $(".coupon-missing-error").hide();
        $(".coupon-error-message").empty();
        if (!$(".coupon-code-field").val()) {
            $formControl.addClass("is-invalid");
            $formControl.attr("aria-describedby", "missingCouponCode");
            $(".coupon-missing-error").show();
            $.spinner().stop();
            return;
        }

        $formControl.removeClass("is-invalid");
        $(".coupon-error-message").empty();
        $body.trigger("promotion:beforeUpdate");

        $.ajax({
            url: $form.attr("action"),
            type: "GET",
            dataType: "json",
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $formControl.addClass("is-invalid");
                    $formControl.attr("aria-describedby", "invalidCouponCode");
                    $(".coupon-error-message").empty().append(data.errorMessage);
                    $body.trigger("promotion:error", data);
                } else {
                    $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                    $(".cart-product-cards").children().not(".loyalty-cart, .espot-banner-slot").remove();
                    $(".cart-product-cards").append(data.itemsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    if (isLoyaltyEnabled) {
                        $("body").trigger("updateLoyaltySection", [parseInt(data.totals.subTotalAdjusted, 10), data.minPurchaseToGetGifts]);
                    }
                    $body.trigger("promotion:success", data);
                }
                $body.trigger("cbtCouponChange", data.cbtResponse);
                $(".coupon-code-field").val("");
                $.spinner().stop();
            },
            error: function (err) {
                $body.trigger("promotion:error", err);
                $body.trigger("cbtCouponChange", err.cbtResponse);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $body.on("click", ".remove-coupon", function (e) {
        e.preventDefault();

        var couponCode = $(this).data("code");
        var uuid = $(this).data("uuid");
        var $deleteConfirmBtn = $(".delete-coupon-confirmation-btn");
        var $productToRemoveSpan = $(".coupon-to-remove");

        $deleteConfirmBtn.data("uuid", uuid);
        $deleteConfirmBtn.data("code", couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $body.on("click", ".delete-coupon-confirmation-btn", function (e) {
        e.preventDefault();

        var url = $(this).data("action");
        var uuid = $(this).data("uuid");
        var couponCode = $(this).data("code");
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $("body > .modal-backdrop").remove();

        $.spinner().start();
        $body.trigger("promotion:beforeUpdate");
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                $(".coupon-uuid-" + uuid).remove();
                $(".cart-product-cards").children().not(".loyalty-cart, .espot-banner-slot").remove();
                $(".cart-product-cards").append(data.itemsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                if (isLoyaltyEnabled) {
                    $("body").trigger("updateLoyaltySection", [parseInt(data.totals.subTotalAdjusted, 10), data.minPurchaseToGetGifts]);
                }
                clearCouponError();
                $.spinner().stop();
                $body.trigger("promotion:success", data);
            },
            error: function (err) {
                $body.trigger("promotion:error", err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $body.on("click", ".cart-page .bonus-product-button", function () {
        $.spinner().start();
        $(this).addClass("launched-modal");
        $.ajax({
            url: $(this).data("url"),
            method: "GET",
            dataType: "json",
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $(".coupon-code-field").on("input", function() {
        var $couponCodeField = $(this);

        $couponCodeField.val($couponCodeField.val().replace(/[!'’"{}()?<>[\]=$\u2018\u0022\u201C\u201D\s+]/g, ""));
    });

    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
